/**
 * Re-exported types and schemas from the AI API spec.
 * Reason for this:
 * 1. We need AI API spec types across multiple packages & apps, circular dependencies be came an issue when imported directly from package.
 * 2. We sometimes need to patch some of the types for better usage / while in dev.
 *
 * Prefer to keep the AI Spec as the source of truth, and only patch here when needed.
 */
import type { z } from 'zod';

/* Type re-exports */
export type {
  AiApiSpec_AddToModelTrainingQueueQueryParams,
  AiApiSpec_AddToPredictionsQueueQueryParams,
  AiApiSpec_Empty,
  AiApiSpec_Error,
  AiApiSpec_GenerateNoteQueueRequestBody,
} from '@timelyapp/ai-engine-api-spec';

/* Zod Schema re-exports */
export {
  AiApiSpec_addToGenerateNoteQueueMutationRequestSchema,
  AiApiSpec_addToModelTrainingQueueQueryParamsSchema,
  AiApiSpec_addToPredictionsQueueQueryParamsSchema,
  AiApiSpec_generateNoteQueueRequestBodySchema,
  AiApiSpec_getAssistantResponseQueryParamsSchema,
} from '@timelyapp/ai-engine-api-spec';

/**
 * Patches and other mutated exports.
 */

import { AiApiSpec_addToGenerateNoteQueueCallbackSchema } from '@timelyapp/ai-engine-api-spec';

export const AiApiSpec_AddToGenerateNoteQueueCallbackBodySchema =
  AiApiSpec_addToGenerateNoteQueueCallbackSchema.shape.body;

// Kubb 4.x inlines enums - extract from callback schema
export const AiApiSpec_noteStyleSchema =
  AiApiSpec_addToGenerateNoteQueueCallbackSchema.shape.body.shape.style.unwrap();
export type aiApiSpec_NoteStyle = z.infer<typeof AiApiSpec_noteStyleSchema>;
